import { useCallback } from 'react';
import omit from 'lodash/fp/omit';
import flow from 'lodash/fp/flow';
import { useHistory } from 'react-router-dom';
import { useResourceManagementContext } from '~/modules/resource-management/common';

const useNavigateToQuickAllocation = () => {
  const { searchCriteria } = useResourceManagementContext();
  const history = useHistory();

  const navigateToQuickAllocation = useCallback(() => {
    const cleanedSearchCriteria = flow(omit('__typename'))(searchCriteria);

    history.push({
      pathname: '/quick-allocation',
      state: { searchCriteria: cleanedSearchCriteria }
    });
  }, [searchCriteria, history]);

  return navigateToQuickAllocation;
};

export default useNavigateToQuickAllocation;
